<template>
  <!-- 部门管理 -->
  <div class="page">
    <el-row :gutter="20" class="page-row">
      <el-col :span="5" class="page-col">
        <!-- 操作按钮 -->
        <div class="operation">
          <DiluButton type="add" @click="add" v-permission="['departmentManagement:add']"></DiluButton>
          <DiluButton type="delete" @click="remove" v-permission="['departmentManagement:remove']"></DiluButton>
        </div>
        <div class="tree">
          <el-tree
            ref="tree"
            :data="dataList"
            show-checkbox
            node-key="id"
            default-expand-all
            :props="defaultProps"
            check-strictly
            @node-click="treeClick"
          >
          </el-tree>
        </div>
      </el-col>
      <el-col :span="19" class="page-col">
        <div class="page-right">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('pages.system.text75')" name="first">
              <DepartmentInfo :info="info" />
            </el-tab-pane>
            <el-tab-pane :label="$t('pages.system.text76')" name="second">
              <DepartmentPersonnel
                :activeName="activeName"
                :tableData="tableData"
                :total="total"
                :pageSize="params.pageSize"
                @currentChange="currentChange"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <!-- 新增部门 -->
    <DepartMentAddModule
      @addClose="addClose"
      :addVisible="addVisible"
      @departmentManagementListAll="departmentManagementListAll"
    />
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DepartmentInfo from "./module/departmentInfo.vue";
import DepartmentPersonnel from "./module/departmentPersonnel";
import DepartMentAddModule from "./module/departMentAddModule.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      info: {}, //基本信息
      activeName: "second",
      addVisible: false, //新增弹窗
      dataList: [],
      defaultProps: {
        children: "departmentList",
        label: "departmentName"
      },
      tableData: [],
      total: 0,
      params: {
        belongCustomerId: "", //平台方id
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        realName: "", //姓名
        roleId: "", //角色id
        username: "", //账号
        departmentId: "", //部门id
      },
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluButton,
    DepartmentInfo,
    DepartmentPersonnel,
    DepartMentAddModule,
  },
  mounted() {
    this.departmentManagementListAll();
    this.accountManagementList();
  },
  methods: {
    //删除
    remove() {
      let arrayId = this.$refs.tree.getCheckedKeys();
      if (arrayId.length < 1) {
        this.$message.error(this.$t('pages.system.text77'));
      } else {
        this.$confirm(this.$t('pages.system.text78'), this.$t('public.text6'), {
          confirmButtonText: this.$t('button.determine'),
          cancelButtonText: this.$t('button.cancel'),
          type: "warning",
        })
          .then(() => {
            this.request
              .departmentManagementDelete({ ids: arrayId })
              .then(() => {
                this.departmentManagementListAll();
                this.$message({
                  type: "success",
                  message: this.$t('public.text7'),
                });
              })
          })
          .catch(() => {});
      }
    },
    //点击节点触发
    treeClick(e) {
      if (e.id < 0) {
        this.departmentManagementListAll();
        this.accountManagementList();
      } else {
        this.params.departmentId = e.id;
        this.departmentManagementInfo(e.id);
        this.accountManagementList();
      }
    },
    //翻页
    currentChange(e) {
      this.params.pageNum = e;
      this.accountManagementList();
    },
    //关闭新增弹窗
    addClose() {
      this.addVisible = false;
    },
    //打开新增弹窗
    add() {
      this.addVisible = true;
    },
    //账号管理-列表（分页）
    accountManagementList() {
      this.params.belongCustomerId = this.platformData.id;
      this.request.accountManagementList(this.params).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //部门管理-查询所有部门
    departmentManagementListAll() {
      this.request.departmentManagementListAll().then((res) => {
        this.dataList = [res.data];
        this.info = {
          departmentName: res.data.departmentName,
          departmentDesc: res.data.platformRemark,
        };
      });
    },
    //部门管理-根据id查询
    departmentManagementInfo(id) {
      let str = '?id=' + id
      this.request.departmentManagementInfo(str).then((res) => {
        this.info = res.data;
      });
    },
  },
};
</script>


<style scoped>
.operation {
  display: flex;
  margin-bottom: 20px;
}
.page-row {
  height: 100%;
}
.page {
  height: 100%;
}
.page-col {
  border-right: 1px solid #eee;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.page-col:last-child {
  border: none;
}
.tree {
  flex: 1;
  overflow: auto;
}
.page-right {
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  /* background-color: #eee; */
}
</style>